import React from 'react';
import Image from 'next/image';
import closeBasicNext from '../../svgs/close_basic_icon_white.svg';
import { NextImageProps } from '../NextImageProps';

export function CloseBasicWhiteNext({ className, width, height, alt }: NextImageProps) {
  return (
    <Image
      width={width}
      height={height}
      className={className}
      src={closeBasicNext}
      alt={alt ?? 'Luk'}
    />
  );
}
